module.exports = __webpack_public_path__ + "img/Excel.49e1267c.jpeg";